import React from "react";

const DataPreprocessingDoc = () => {
  return (
    <div className='container'>
        <h1 className='text-light text-center'>Data Preprocessing</h1>

      <p className='text-light'>
        Data preprocessing is an important step in the machine learning process.
        It involves cleaning, transforming, and preparing the data for use in a
        model. MLGUI Web Tool provides a range of data preprocessing options to
        help users prepare their data for modeling. These options include, but
        not limited to:
        <br />
        <br />
        <li>
          <strong> Cleaning:</strong> Removing missing values, duplicates, and
          outliers from the data.
        </li>
        <br />
        <li>
          <strong>Transformation:</strong>Changing the format or structure of
          the data make it suitable for use in a model.
        </li>
        <br />
        <li>
          {" "}
          <strong>Data normalization:</strong> Scaling the data to a common
          range to help improve the performance of the model.
        </li>
        <br />
        <li>
          <strong> Splitting:</strong> Dividing the data into training,
          validation and test sets to evaluate the model's performance.
        </li>
        <br />
        Users can perform these preprocessing steps with the help of the
        user-friendly interface provided by the MLGUI Web Tool. This makes it
        easy for students and developers to prepare their data for modeling,
        even if they have no prior experience in data preprocessing.
      </p>
    </div>
  );
};

export default DataPreprocessingDoc;
